import {GeoJSON} from "geojson";
import {Feature} from "ol";
import {Geometry} from "ol/geom";

export type FeatureKind = 'predefined' | 'custom';

interface UserFeatureBase {
    id: string;
    kind: FeatureKind;
    title: string;
    geometryType: GeoJSON.GeoJsonGeometryTypes;
    featureCollection: GeoJSON.FeatureCollection;
    srid?: number;
    shared?: boolean;
}

export interface CustomUserFeature extends UserFeatureBase {
    id: string;
    kind: 'custom';
    title: string;
    geometryType: GeoJSON.GeoJsonGeometryTypes;
    featureCollection: GeoJSON.FeatureCollection;
}

export interface PredefinedUserFeature extends UserFeatureBase {
    id: string;
    kind: 'predefined';
    title: string;
    geometryType: GeoJSON.GeoJsonGeometryTypes;
    featureCollection: GeoJSON.FeatureCollection;
    sourceLayerId: number;
}

export type UserFeature = CustomUserFeature | PredefinedUserFeature;

export interface UserFeatureId {
    kind: FeatureKind;
    id: string;
    mapFeatureIdx?: string;
}
const idRegex = /(?:unsaved-)?(custom|predefined)-(\d+):(\d+)/;

export function decodeUserFeatureId(id: string) : UserFeatureId {
    let match = id.match(idRegex);

    if (match) {
        return {
            kind: <FeatureKind> match[1],
            id: match[2],
            mapFeatureIdx: match[3]
        }
    }
    return null;
}

export interface FeatureAndUiState {
    userFeature: UserFeature;
    visible: boolean;
    deleting: boolean;
    saving?: boolean;
    mapFeatures?: Feature<Geometry>[];
}